const e = {
  name: "Vnode",
  props: {
    nodes: {
      type: [String, Object, Array],
      required: !0
    }
  },
  render() {
    return this.nodes;
  }
};
export {
  e as default
};
//# sourceMappingURL=vnode.js.map
